export const yearFormat = (year, lang) => {
    switch (lang) {
        case 'th':
            return year

        default:
            if (lang && lang.language === 'th') return year
            return year - 543
    }
}

export default {
    yearFormat
}
